/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Glyphicon } from "react-bootstrap";

const RunsheetStatus = ({ status, jobs }) => {
  const completedJobs = jobs.filter(job => job.status === "COMPLETED");
  const jobsPerTotal = `${completedJobs.length}/${jobs.length}`;

  switch (status) {
    case "OPENED":
      return (
        <div title="Opened">
          <span className="bluedot" />
          {jobsPerTotal}
        </div>
      );
    case "IN_PROGRESS":
      return (
        <div title="In Progress">
          <span className="sprite-image inprogress-image" />
          {jobsPerTotal}
        </div>
      );
    case "COMPLETED":
      return (
        <div>
          <span className="completed-icon" title="Completed">
            <Glyphicon glyph="ok" />
          </span>
          {jobsPerTotal}
        </div>
      );
    case "CANCELLED":
      return (
        <div>
          <span className="cancelled-icon" title="Cancelled">
            <Glyphicon glyph="remove" />
          </span>
          {jobsPerTotal}
        </div>
      );
    default:
      return (
        <div title="Created">
          <span className="greendot" />
          {jobsPerTotal}
        </div>
      );
  }
};
RunsheetStatus.propTypes = {
  status: PropTypes.string.isRequired,
  jobs: PropTypes.array.isRequired
};

export default RunsheetStatus;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetStatus.js